import { postRequest } from '../utils/provider';
import { ApiResponse } from '../utils/responseTransform';

interface RouteDetailsAPI {
  startsAt: string;
  endsAt: string;
  overviewPolyline: string;
  legs: RouteLegInfo[];
  distance: number;
  duration: number;
  routingInfo: {
    plannedRoute: string;
    actualRoute: Nullable<string>;
  };
}
export async function requestRouteDetails(payload: RouteDetailsType): Promise<ApiResponse<RouteDetailsAPI>> {
  return postRequest('routes/summary', payload);
}
